import { FC, ReactElement } from 'react'
import { Link } from 'react-router-dom'

import { PayloadProps } from '../../types/footer'
import Item from './item'

import './itemList.css'

const ItemList: FC<PayloadProps> = (props: PayloadProps): ReactElement => {
  const { items } = props.payload
  return (
    <div className="item-list-container">
      {items
        ?.filter((item) => item.subTitle)
        .map((item) => {
          return (
            <div className="item-list__category" key={item.title}>
              <Link to={item.url as string} className="item-list__bold">
                {item.title}
              </Link>
              {item.subTitle && <Item key={item.title} {...item} />}
            </div>
          )
        })}
      <div>
        {items
          ?.filter((item) => !item.subTitle)
          .map((item) => {
            return (
              <div className="item-list__category item-list-nosubtitle" key={item.title}>
                {item.role === 'help' ? (
                  <a className="item-list__bold" href={item.url}>
                    {item.title}
                  </a>
                ) : (
                  <Link to={item.url as string} className="item-list__bold">
                    {item.title}
                  </Link>
                )}
              </div>
            )
          })}
      </div>
    </div>
  )
}

export default ItemList
